import { parseURI, URITypeMap } from '@spotify-internal/uri';

// Transforms any URL with trail endings to URIs to avoid issues in backend
export const getURI = (uri: string) => {
  return parseURI(uri)?.toURI();
};

export const getAlbumUris = (uris: string) => {
  return uris
    .trim()
    .split(/[ ,|;]+/)
    .map(albumUri => getURI(albumUri))
    .join();
};

export const validComment = (comments: string | undefined) => {
  if (!comments) {
    return true;
  }
  let valid = true;
  comments.split(' ').forEach(element => {
    if (
      parseURI(element)?.type === URITypeMap.ARTIST ||
      parseURI(element)?.type === URITypeMap.ALBUM
    ) {
      valid = false;
    }
  });
  return valid;
};
